import {IProjectSettings, ITodoCreatedClosed} from "./Interfaces";
import {Plugin} from "./Main";
import {
    app,
    ml,
    IDataStorage,
    XRTodo, refLinkStyle, refLinkTooltip, Notifications, UIToolsConstants, IReference, TodoTypes
} from "../../../sdk/client";
import {IDashboardPage, IDashboardParametersBase} from "../../../sdk/plugins/interfaces";
import {Project} from "../../../sdk/objects/Project";
import { GetTodosAck, Todo } from "../../../sdk/rest-api";
import { NotificationsBL } from "../../../core/common/businesslogic/NotificationsBL";



interface IDashboardParameters extends IDashboardParametersBase  {
    selection: IReference[];
}
// eslint-disable-next-line no-unused-vars
export class DashboardPage implements IDashboardPage<IDashboardParameters> {
    settings: IProjectSettings;

    _root: JQuery;

    elementsLst: Todo[];


    constructor(private project: Project, private projectStorage: IDataStorage,private popupModeOrControl = false, private currentFolder:string = undefined) {
        this.settings = {
            ...Plugin.config.projectSettingsPage.defaultSettings,
            ...project.getItemConfig().getSettingJSON(Plugin.config.projectSettingsPage.settingName, {})
        };
    }

    /** Customize static HTML here */
    private getDashboardDOM(): JQuery {
        return $(this.dashboardDOM);
    }




    /** Add interactive element in this function */
    renderProjectPage() {
        app.itemForm.append(
            ml.UI.getPageTitle(
                Plugin.config.dashboard.title,
                () => {
                    return this._root;
                },
                () => {
                    this.onResize();
                }
            )
        );
        app.itemForm.append(this.render());
    }




    eventsAttached: boolean;

    public async loadNotifications() {
        let that = this;

        $("#waitForIt").html("");
        $("#waitForIt").append(ml.UI.getSpinningWait("please wait..."));
        $("#NOOContent").hide();
        $("#NOONoItems").hide();

        $(".spinningWait").show();

        this.elementsLst = [];
        $('.addedNotifRow').remove();

        let allNotifications: GetTodosAck = await this.project.getTodos(undefined, true, true);
        if (allNotifications.todos.length > 0) {
            this.elementsLst = allNotifications.todos.reverse();
            this.renderNotifTable(allNotifications.todos);

            $("#NOOContent").show();

            this.drawNotifCharts(this.elementsLst);

            this.drawCumulativeChart(this.elementsLst);

            $(".spinningWait").hide();

            let redraw = () => {
                this.drawNotifCharts(this.elementsLst)
                this.drawCumulativeChart(this.elementsLst);

            };
            if (!this.eventsAttached) {
                $(document).on("chartResize", redraw);
                $(document).on("contextFrameResized", redraw);
                $(document).on("sidebarResized", redraw);
                this.eventsAttached = true;
            }

        } else {
            $(".spinningWait").hide();
            $("#NOONoItems").show();
        }

    }
    start() {
        let that = this;

        // No automatic start in case of popup
        if (this.popupModeOrControl)
            return;
        // Get last opened Notif for that user.
        this.loadNotifications();

    }


    renderNotifTable(lst: Todo[]) {
        let that = this;
        $('.addedNotifRow').remove();

        for (let i = 0; i < lst.length; i++) {
            let notif = lst[i];
            let template = $("#NotifRow").clone();
            template.find("[data-attr='itemRef']").html("");

            let jId = $("<span>"+notif.itemRef+"</span>").refLink({
                id: notif.itemRef, title: app.getItemTitle(notif.itemRef), style: refLinkStyle.link, tooltip: refLinkTooltip.html, hideTitle: false
            });

            template.find("[data-attr='itemRef']").append(jId);

            template.find("[data-attr='title']").html(NotificationsBL.getMessage(<XRTodo>notif));
            template.find("[data-attr='assignee']").html(notif.login);//+ " --> " + Notif.creationDate.format("YYYYMMDD") + "|" + Notif.executionDate.format("YYYYMMDD"));
            template.find("[data-attr='date']").html("");
            template.find("[data-attr='date']").html("").append("Created " +  moment(new Date(notif.createdAt)).fromNow() ).attr("title",notif.createdAtUserFormat);

            if(notif.closedAt == undefined)
            {
                template.find("[data-attr='date']").append(" and completed " +  moment(new Date(notif.createdAt)).fromNow() ).attr("title",notif.createdAtUserFormat);

            }
            template.find("[data-attr='assignedBy']").html(notif.originatorLogin);//+ " --> " + Notif.creationDate.format("YYYYMMDD") + "|" + Notif.executionDate.format("YYYYMMDD"));

            let typeIcon="";
            switch( notif.action.todoType)
            {
                case TodoTypes.needReview :
                case TodoTypes.reviewsDone :
                    typeIcon ="fal fa-comment-alt-lines";
                    break;
                case TodoTypes.user :
                    typeIcon ="fal fa-tasks";
                    break;
                case TodoTypes.needSignature :
                case TodoTypes.signaturesDone :
                case TodoTypes.signatureRejected:
                    typeIcon="fal fa-file-signature" ;
                    break;
                case TodoTypes.needApprove :
                case TodoTypes.approveDone :
                    typeIcon="fal fa-file-f-check" ;
                    break;

                case TodoTypes.needTraining :
                    typeIcon="fal fa-chalkboard-teacher" ;
                    break;
                default:
                    typeIcon ="fal fa-tasks";
                    break;
            }

            template.find("[data-attr='type']").html("<i class='"+ typeIcon+"'/>");//+ " --> " + Notif.creationDate.format("YYYYMMDD") + "|" + Notif.executionDate.format("YYYYMMDD"));
            template.find("[data-attr='type'] i").css("color",notif.closedAt != undefined ? "var(--GreenSushi)":"var(--RedPersimmon)");


            template.removeClass("hidden");
            template.addClass("addedNotifRow")
            $('#NotifList').append(template);
        }
        if (lst.length == 0) {
            $('#NotifList').append('<tr class="addedNotifRow" class="hidden"> <td colspan="4"> No data to display</td></tr>');

        }
    }

    filterNotifByUserByStatus(filter: any) {
        let that = this;
        if (filter == undefined) {
            this.renderNotifTable(this.elementsLst);
        }
        else {
            let elementToDisplay = this.elementsLst;
            if (filter.user != "") {
                elementToDisplay = elementToDisplay.filter(o => { return o.login == filter.user });

            }
            if(filter.status == "Pending")
            {
                elementToDisplay = elementToDisplay.filter(o=> {return o.closedAt == undefined});
            }
            if(filter.status == "Done")
            {
                elementToDisplay = elementToDisplay.filter(o=> {return o.closedAt != undefined});
            }
            this.renderNotifTable(elementToDisplay);
        }
    }

    public render():JQuery {
        let that = this;

        this._root = this.getDashboardDOM();

        $("#NOOContent").hide();
        let baseControl = $("#itemSelectionNOO")

        if (this.popupModeOrControl) {
            baseControl.hide();
        }
        //Table filter
        $("#NOOInputFilter", this._root).on("keyup", function (e) {
            let value = $(e.target).val().toLowerCase();
            $("#NotifList tr").each(function (index, elem) {
                $(elem).toggle($(elem).text().toLowerCase().indexOf(value) > -1)
            });
        });

        $(document).on("filterNotifByStatus",  (event, arg1)  =>{
            this.filterNotifByUserByStatus(arg1);
        });
        $(document).on("filterNotifByUserByStatus",  (event, arg1) => {
            this.filterNotifByUserByStatus(arg1);
        });
        if (!this.popupModeOrControl) {
            setTimeout((o:any) =>  this.start(), 10);
        }
        return  this._root;

    }
    installCopyButtons(title : string) {
        let that = this;

        $("#NOOTableHeader i").remove();
        ml.UI.copyBuffer($("#NOOTableHeader"), "copy list to clipboard", $("#NOOContent"), this._root, (copied: JQuery) => {
            $(".doNotCopy", copied).remove();
            let filter = $("#NOOInputFilter").val();
            // Different if popup/Control mode
            $("#NOOTitleForCopy", copied).html("<h1>" +title+ "</h1> <span> <b> Date:</b> " + ml.UI.DateTime.renderCustomerHumanDate(new Date()) + "<br/>" + (filter != "" ? "<b>Filter : </b>" + filter + "<br/>" : "") + "<br/>");
        });

        $("#NOOPieChartTitle i").remove();
        ml.UI.copyBuffer($("#NOOPieChartTitle"), "copy  to clipboard", $("#overviewGraph"), this._root, (copied: JQuery) => {
            ml.UI.fixC3ForCopy(copied);

        });

        $("#NOOBarChartTitle i").remove();
        ml.UI.copyBuffer($("#NOOBarChartTitle"), "copy  to clipboard", $("#overviewPerUser"), this._root, (copied: JQuery) => {
            ml.UI.fixC3ForCopy(copied);

        });



    }
    private drawNotifCharts(inputData: Todo[]) {
        let that = this;
        // Create the data table.
        let mySet = inputData.map(x => x.login);
        let users = [];
        for (let i = 0; i < mySet.length; i++) {
            if (users.indexOf(mySet[i]) < 0) {
                users.push(mySet[i]);
            }
        }

        let groups = [ "Done", "Pending"];
        let convertedData: Array<Record<string, c3.Primitive>> = [];

        //var usersData = [["User", "Passed", "Failed", "New", "Progress", { role: 'annotation' }]]
        for (let i = 0; i < users.length; i++) {
            let user = users[i];
            let line: Record<string, c3.Primitive> = { "user": user };
            line["Done"] = inputData.filter( (elem) => { return elem.login == user && elem.closedAt !=undefined }).length;
            line["Pending"] = inputData.filter( (elem) => { return elem.login == user && elem.closedAt ==undefined }).length;
            convertedData.push(line);
        }

        //Calculate width
        let containerWidth= $("#overviewPerUser").width();

        let itemWidth = containerWidth/15;

        let graphWidth = -1 ;

        if( users.length > 15)
        {
            graphWidth = itemWidth * (users.length+1);
            $("#overviewPerUser").css("overflow-x","auto");
            $("#overviewPerUser").css("overflow-y","hidden");
        }


        c3.generate({
            bindto:'#overviewPerUser',
            size: {
                width: graphWidth!=-1?graphWidth:undefined,
            },
            data: {
                json: convertedData,
                keys: {
                    x: 'user', // it's possible to specify 'x' when category axis
                    value: groups,
                },
                type:"bar",
                groups:[groups],
                colors:{
                    "Done": UIToolsConstants.CIColors.GreenSushi.color,
                    "Pending": UIToolsConstants.CIColors.RedPersimmon.color
                },
                onclick:( d,element)=>
                {
                    $(document).trigger("filterNotifByUserByStatus", [{ user: convertedData[d.index].user, status: d.id }]);
                }
            },
            axis: {
                x: {
                    type: 'category',
                    tick: {
                        fit:true,
                        rotate: 65,
                        multiline:false,
                        multilineMax:1

                    }
                },
            },
            legend:
                {
                    position:'inset',
                    inset: {
                        anchor: graphWidth==-1?"top-right" :"top-left"
                    }
                },
            zoom: {
                enabled: false,
                rescale: false,
                extent: [1, 5]
            }
        });





    }

    private drawCumulativeChart(lst: Todo[]): any {

        let dates = lst.map((item) => { return moment(item.createdAt) });
        dates = dates.concat(lst.filter( o => {return o.closedAt !=undefined}).map((item) => {
            return  moment(item.closedAt)
        }));

        let mapDates = dates.map((item) => { return moment([item.year(), item.month(), item.date()]) }).filter((m) => { return m.isValid() });
        let filterMapDates: ITodoCreatedClosed[] = [];
        for (let index = 0; index < mapDates.length; index++) {
            const element = mapDates[index];
            if (filterMapDates.filter((o) => { return o.date.format("YYYYMMDD") === element.format("YYYYMMDD") }).length == 0) {
                filterMapDates.push({ date: element, created: 0, remaining: 0 });
            }
        }
        filterMapDates = filterMapDates.sort((a, b) => { return a.date.valueOf() - b.date.valueOf() });

        for (let index = 0; index < filterMapDates.length; index++) {

            let nbCreated = lst.filter((element) => {
                let creationDate = moment(element.createdAt);
                let d = moment([creationDate.year(),creationDate.month(), creationDate.date()]);
                return (d.toDate() <= filterMapDates[index].date.toDate())
            }).length;

            let nbClosed = lst.filter((element) => {
                if(element.closedAt)
                {
                    let closedAt = moment(element.closedAt);
                    let d = moment([closedAt.year(), closedAt.month(), closedAt.date()]);
                    return (d.toDate() <= filterMapDates[index].date.toDate())
                }
                return false;
            }).length;

            filterMapDates[index].created = nbCreated;
            filterMapDates[index].remaining = nbCreated- nbClosed;
        }

        let date: any[] = ["Date"];
        let created: any[] = ["Created"];
        let remainings: any[] = ["Pending"];

        for (let i = 0; i < filterMapDates.length; i++) {
            date.push(filterMapDates[i].date.toDate());
            created.push(filterMapDates[i].created);
            remainings.push(filterMapDates[i].remaining);
        }


        c3.generate(
            {
                bindto:'#cumulativeChart',
                data:{
                    columns: <Array<[string, ...c3.PrimitiveArray]>>[date, created, remainings],
                    x:"Date",
                    colors:{
                        Created: UIToolsConstants.CIColors.GreenSushi.color,
                        Pending: UIToolsConstants.CIColors.RedPersimmon.color
                    }
                },
                axis: {
                    x: {
                        type: 'timeseries',
                        tick: {
                            format: '%Y-%m-%d',
                            count:10,
                            fit: true
                        }
                    }
                },
                point: {
                    show: false
                },
                zoom: {
                    enabled: false,
                    rescale: true,
                    extent: [1, 5]
                }

            }

        )
        $("#cumulativeChart .c3-event-rects").click(() =>{
            $(document).trigger("filterNotifByUserByStatus", [{ user: "", status: ""}]);
        });
    }


    onResize() {
        /* Will be triggered when resizing. */
    }

    private dashboardDOM = `<div class="panel-body-v-scroll fillHeight">
        <style>
        .chart {
            width: 90%;
            min-height: 350px;
            cursor:pointer;
        }
        .bigChart
        {
            min-height:700px;
        }
        </style>
        <div  style="margin:10px;">
            <div class="row product doNotCopy">
                <div id="itemSelectionNOO" class="col-lg-12 col-md-5 col-md-offset-0"></div>
            </div>
            <div class="row" id="waitForIt" class="spinningWait">

            </div>
            <div id="NOONoItems">Not enough data to display Notification Overview </div>
        </div>
        <div id="NOOContent" class="" style="margin:10px;" >

            <div class="row doNotCopy">
                <div class="col-lg-6 ">
                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <h3 class="panel-title" id="">Overview</h3>
                        </div>
                        <div class="panel-body">
                            <div id="cumulativeChart" class="chart"></div>
                        </div>
                    </div>
                </div>
                <div  class="col-lg-6">
                    <div class="panel panel-default">
                        <div class="panel-heading">
                            <h3 class="panel-title" id="NOOBarChartTitle">Overview per user</h3>
                        </div>
                        <div class="panel-body">
                            <div id="overviewPerUser" class="chart" ></div>
                        </div>
                    </div>
            </div>
            </div>
            <div class="row" id="NOOTitleForCopy">
            </div>
            <div class="row doNotCopy">
                <div class="col-lg-3 ">
                    <h3 id="NOOTableHeader">Notifications list</h3>
                </div>
                <div class=" col-lg-7">
                </div>
                <div class=" col-lg-2">
                    <input type="text" id="NOOInputFilter" style="margin-bottom:10px;" placeholder="filter..." class="doNotCopy  form-control"></input>
                </div>
            </div>
            <div class="table-responsive">
                    <table class="table table-condensed table-borderless table-hover" id="NOOTable">
                        <thead>
                            <tr>
                                <th style='width:20px; '></th>
                                <th style="min-width: 65px;">ID<span></span></th>
                                <th>Date</th>
                                <th>Description</th>
                                <th>Assignee</th>
                                <th>Assigned by</th>
                            </tr>
                        </thead>
                        <tbody id="NotifList">

                            <tr id="NotifRow" class="hidden">
                            <td data-attr="type"></td>
                            <td data-attr="itemRef">Notif-XXX</td>
                                <td data-attr="date">Verify wheels count</td>
                                <td data-attr="title">Verify wheels count</td>
                                <td data-attr="assignee">Francois</td>
                                <td data-attr="assignedBy"></td>
                            </tr>

                        </tbody>
                    </table>
                </div>

        </div></div> `;
}
